import { getBase64ImageByUrl } from '~src/utils';
import { canvasJsonToImage } from '~core';

export const getImageFromPage = async (page) => {
  let image;

  if (page.imgData) {
    // For visited pages, imgData is already a clean base64 string
    image = page.imgData;
  } else if (page.preview && page.preview.url) {
    try {
      // Use JPEG format to match what the PDF expects
      image = await getBase64ImageByUrl(page.preview.url, 'image/jpeg', 0.92);
    } catch (err) {
      console.warn('Failed to download preview, generating at runtime', err);
      const generated = await canvasJsonToImage(page.canvasJson);
      // Ensure we return just the base64 string, not the full object
      image = generated.base64;
    }
  } else {
    const generated = await canvasJsonToImage(page.canvasJson);
    image = generated.base64;
  }

  // Ensure the image is a clean base64 string without data URL prefix
  if (image && image.includes('data:')) {
    image = image.split(',')[1];
  }

  return image;
};
